import { Visibility, VisibilityOff } from '@mui/icons-material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { Box, IconButton, InputAdornment, Typography } from '@mui/material';
import React, { useState } from 'react';
import { Button, Input, Modal, ProgressCircle } from '../../../components';
import {
  useDispatch,
  useSelector,
  userSlice,
  fetchUserUpdatePasswordWithoutOld,
} from '../../../stores';
import { handleErrors } from '../../../utils/Helpers';
import { passwordSchema } from './validations';

export const PasswordChangeModal: React.FC = () => {
  const dispatch = useDispatch();
  const { userInfo, userUpdateLoading, passwordChangeIsOpen } = useSelector(
    (state) => state.userReducer,
  );
  const [formData, setFormData] = useState({
    password: '',
    passwordConfirmation: '',
  });
  const [errors, setErrors] = useState<{ [key: string]: string }>({});
  const [showPassword, setShowPassword] = useState(false);
  const [showPasswordConfirmation, setShowPasswordConfirmation] =
    useState(false);

  const handleClose = () => {
    dispatch(userSlice.actions.togglePasswordChangeIsOpen());
    setFormData({ password: '', passwordConfirmation: '' });
    setErrors({});
  };

  const handleSubmit = () => {
    setErrors({});
    passwordSchema
      .validate(formData, { abortEarly: false })
      .then(() => {
        dispatch(
          fetchUserUpdatePasswordWithoutOld({
            userId: userInfo?.id?.toString() || '',
            newPassword: formData.password,
          }),
        ).then(() => {
          handleClose();
        });
      })
      .catch((err) => {
        setErrors(handleErrors(err));
      });
  };

  return (
    <Modal
      open={passwordChangeIsOpen}
      onClose={handleClose}
      title='Alterar senha do usuário'
    >
      <>
        {userUpdateLoading ? (
          <Box sx={{ display: 'flex', justifyContent: 'center', p: 3 }}>
            <ProgressCircle color='primary' />
          </Box>
        ) : (
          <>
            <Typography
              id='modal-modal-description'
              variant='h6'
              sx={{ mt: 2, fontWeight: 'bold' }}
            >
              Preencha os campos abaixo
            </Typography>
          </>
        )}
        <Box
          sx={{
            width: '100%',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
          }}
        >
          <Input
            data-testid='password'
            type={showPassword ? 'text' : 'password'}
            label='Nova senha'
            InputProps={{
              endAdornment: (
                <InputAdornment position='end'>
                  <IconButton
                    aria-label='toggle password visibility'
                    onClick={() => setShowPassword(!showPassword)}
                    onMouseDown={() => setShowPassword(!showPassword)}
                  >
                    {showPassword ? <Visibility /> : <VisibilityOff />}
                  </IconButton>
                </InputAdornment>
              ),
            }}
            value={formData.password}
            onChange={(value) => setFormData({ ...formData, password: value })}
            errorMessage={errors && errors.password}
          />
          <Input
            data-testid='passwordConfirmation'
            type={showPasswordConfirmation ? 'text' : 'password'}
            label='Confirme a nova senha'
            InputProps={{
              endAdornment: (
                <InputAdornment position='end'>
                  <IconButton
                    aria-label='toggle password visibility'
                    onClick={() =>
                      setShowPasswordConfirmation(!showPasswordConfirmation)
                    }
                    onMouseDown={() =>
                      setShowPasswordConfirmation(!showPasswordConfirmation)
                    }
                  >
                    {showPasswordConfirmation ? (
                      <Visibility />
                    ) : (
                      <VisibilityOff />
                    )}
                  </IconButton>
                </InputAdornment>
              ),
            }}
            value={formData.passwordConfirmation}
            onChange={(value) =>
              setFormData({ ...formData, passwordConfirmation: value })
            }
            errorMessage={errors && errors.passwordConfirmation}
          />
          <Button
            variant='contained'
            label='Salvar'
            type='submit'
            style={{ width: '100%', margin: 0, marginTop: 30 }}
            loading={userUpdateLoading}
            onClick={handleSubmit}
          />
          <Button
            color='error'
            variant='contained'
            startIcon={<ArrowBackIcon />}
            label='Voltar'
            type='reset'
            style={{ width: '100%', margin: 0, marginTop: 10 }}
            onClick={() => handleClose()}
          />
        </Box>
      </>
    </Modal>
  );
};
